import { useEffect } from 'react';
import { servicesData } from '@/mocks/homeData';

export default function ServicesSection() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll('.services-animate');
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="servicios" className="py-20 md:py-32 bg-yakis-offwhite relative">
      <div className="section-container">
        {/* Header */}
        <div className="max-w-2xl mb-12 md:mb-16">
          <div className="services-animate animate-on-scroll mb-4">
            <span className="text-yakis-gold text-sm font-semibold tracking-wider uppercase">
              Nuestra Especialidad
            </span>
          </div>
          <h2 className="services-animate animate-on-scroll font-display font-bold text-3xl sm:text-4xl md:text-5xl text-yakis-navy leading-tight">
            Servicios diseñados
            <br />
            para <span className="text-yakis-gold">empresas líderes</span>
          </h2>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {servicesData.map((service, index) => (
            <div
              key={service.id}
              className="services-animate animate-on-scroll group bg-white rounded-2xl p-6 md:p-8 transition-all duration-500 hover:shadow-xl hover:-translate-y-1 cursor-default"
              style={{ transitionDelay: `${index * 80}ms` }}
            >
              {/* Icon */}
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-yakis-gold/10 text-yakis-gold mb-5 transition-all duration-300 group-hover:bg-yakis-gold group-hover:text-white">
                <i className={`${service.icon} text-2xl`} />
              </div>

              {/* Title */}
              <h3 className="font-display font-semibold text-lg text-yakis-navy mb-3">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-sm text-yakis-silver leading-relaxed mb-5">
                {service.description}
              </p>

              {/* Features */}
              <div className="flex flex-wrap gap-2">
                {service.features.map((feature) => (
                  <span
                    key={feature}
                    className="inline-flex items-center gap-1 px-3 py-1 bg-yakis-offwhite rounded-full text-xs text-yakis-silver font-medium"
                  >
                    <i className="ri-check-line text-yakis-gold" />
                    {feature}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}